import React from 'react';
import PropTypes from 'prop-types';
import { EXTERNAL_URL } from '../constants';


const propTypes = {
    urlKey: PropTypes.string.isRequired,
};

const ExternalLink = props => {
    const { children, urlKey, ...rest } = props;

    if (!urlKey) return null;

    const href = EXTERNAL_URL[urlKey] || null;

    if (!href) return null;

    return (
        <a href={href} target="_blank" rel="noopener noreferrer" {...rest}>
            { children }
        </a>
    );
};

ExternalLink.propTypes = propTypes;

export default ExternalLink;

